'use strict';

var SnapshotDatesChartLegendDirective = function SnapshotDatesChartLegendDirective() {
  return {
    restrict: 'E',
    template: require('../templates/snapshot-dates-chart-legend.html'),
    scope: {
      chartData: '=',
      reloadChart: '=',
      resetChart: '='
    },
    replace: true,
    controller: 'SnapshotDatesChartLegendController',
    link: function link($scope) {
      $scope.$watch('chartData', function () {
        $scope.initLegendFilters();
      });
    }
  };
};
SnapshotDatesChartLegendDirective.$inject = [];
module.exports = SnapshotDatesChartLegendDirective;